<div class="container">
    <h2>Page Not Found</h2>
    <p>Click the button below to go to the Home page</p>
    <a href="/en" class="btn btn-primary">HOME</a>
</div>
